import RequiredJoinGroupHOC from '@/components/elements/lesson/RequiredJoinGroupHOC';
import { generateTrialLearningLink } from '@/helpers/generatePathname';
import { useRouter } from 'next/router';
import { Button } from '../Button';
import Tooltips from '../Tooltips/Tooltips';
import { Typography } from '../Typography';
import { generateIcon, getClassNamesCourseDetailRow } from './helper';
import { CourseDetailRowProps } from './types';

const CourseDetailRow = ({
  title,
  status,
  duration,
  materialType,
  endAdornment,
  className,
  disabled = false,
  allowTrial,
  id,
  ...restProps
}: CourseDetailRowProps) => {
  const router = useRouter();
  const { cid } = router.query;

  return (
    <div
      tabIndex={1}
      className={getClassNamesCourseDetailRow(disabled, className)}
      {...restProps}
    >
      {generateIcon(materialType, status)}
      <Tooltips title={title} placement="bottom">
        <div className="w-full">
          <Typography
            variant="body2"
            className="line-clamp-2 break-word-legacy"
          >
            {title}
          </Typography>
        </div>
      </Tooltips>
      {allowTrial && (
        <RequiredJoinGroupHOC
          className="flex-shrink-0"
          href={generateTrialLearningLink({
            courseId: cid as string,
            materialId: id,
            materialType: materialType,
          })}
        >
          <Button size="small" emphasis="medium">
            Học thử
          </Button>
        </RequiredJoinGroupHOC>
      )}
      <Typography variant="body3">{duration}</Typography>
      {endAdornment}
    </div>
  );
};

export default CourseDetailRow;
